import { ChangeDetectorRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
//import { InspeccionService } from 'src/app/services/inspeccion.service';
import { ObservableInspService } from 'src/app/services/observable_insp';
import { UserService } from 'src/app/services/user.service';
var IngresosInspComponent = /** @class */ (function () {
    function IngresosInspComponent(_formBuilder, _inspeccionService, observableService, _changeDetector) {
        this._formBuilder = _formBuilder;
        this._inspeccionService = _inspeccionService;
        this.observableService = observableService;
        this._changeDetector = _changeDetector;
        this.idsTiposOcupaciones = [];
        this.descTipo = [];
        this.boxSelected = [];
        //console.log("avu ingresos-inp constructor")
        this.checkch = [];
        this.observacionForm = this._formBuilder.group({
            observacion: ["", [Validators.required]],
        });
        this.formTipo = this._formBuilder.group({
            ArrForms: this._formBuilder.array([], Validators.required),
        });
        //console.log("avu ingresos-inp constructor 2")
        this.getTipoIngreso();
    }
    IngresosInspComponent.prototype.ngOnInit = function () {
        this.boxSelected = [];
        console.log('ventana step 3');
    };
    IngresosInspComponent.prototype.getTipoIngreso = function () {
        var _this = this;
        //console.log("inicio get ts");
        this._inspeccionService.getTipoIngreso().subscribe(function (response) {
            //console.log('getTipoIngreso response ', response);
            _this.tipoIng = [];
            //console.log("Tipo de Ocupaciones", response.data);
            _this.respTipoIngreso = response.data;
            _this.tipoIng = _this.respTipoIngreso.map(function (tipo) {
                //console.log("val", this.tipoIng, tipo.fieldData);
                return tipo.fieldData;
                //console.log("val", this.tipoIng, tipo.fieldData);
            });
            _this.tipoIng = _this.tipoIng.filter(function (data) { return (data._TRAEXP_Cod === 4); });
            //console.log(this.tipoIng, 'tip');
            _this.inicializarFormulario();
        }, function (error) {
            console.log('error', error);
        });
    };
    IngresosInspComponent.prototype.getFormulario = function () {
        var _this = this;
        this.idsTiposOcupaciones = [];
        this.descTipo = [];
        this.observableService.comentario$.emit(this.observacionForm.controls.observacion.value);
        //console.log('DATA CHECK', this.formArray);
        this.seleccionados = this.formTipo.value.ArrForms;
        //console.log('valor formarray', this.seleccionados);
        this.seleccionados.forEach(function (tipo) {
            // console.log('tipo:: ', tipo);
            if (tipo.tipoOcupacionCheck === true) {
                _this.idsTiposOcupaciones.push(tipo.tipoOcupacionId);
                _this.descTipo.push(tipo.tipoOcupacionLabel);
            }
            _this.observableService.tiposInsp$.emit(_this.idsTiposOcupaciones.toString());
            _this.observableService.siglasId$.emit(_this.descTipo.toString());
            //console.log('aaaa', this.idsTiposOcupaciones.toString());
            //console.log('eee', this.descTipo.toString() );
        });
        this.idsTiposOcupaciones;
        // // if (this.thirdFormGroup.controls.coordenada1.status=="VALID",
        // //     this.thirdFormGroup.controls.coordenada2.status=="VALID"
        // // ) {
        // //    this.blockButton  = true ;
        // // }
    };
    IngresosInspComponent.prototype.checkboxChange = function (event, check) {
        //console.log('event.checked:: ', check);
        this._changeDetector.detectChanges;
        this.boxSelected = this.formArray.controls;
        if (event) {
            var index = this.checkch.findIndex(function (c) { return c.tipoOcupacionId.value === check.tipoOcupacionId.value; });
            if (index !== -1) {
                this.checkch.splice(index, 1);
            }
            else {
                this.checkch.push(check);
            }
        }
        else {
            var index = this.checkch.findIndex(function (c) { return c.tipoOcupacionId.value === check.tipoOcupacionId.value; });
            if (index !== -1) {
                this.checkch.splice(index, 1);
            }
        }
        this._changeDetector.detectChanges;
        //console.log('box selected', this.checkch);
    };
    IngresosInspComponent.prototype.inicializarFormulario = function () {
        this.formTipo = this._formBuilder.group({
            ArrForms: this._formBuilder.array([], Validators.required),
        });
        this.formArray = this.formTipo.controls.ArrForms;
        for (var i = 0; i < this.tipoIng.length; i++) {
            var tipo = this.tipoIng[i];
            // console.log('tipo:: ', tipo);
            this.formArray.push(this._formBuilder.group({
                tipoOcupacionLabel: tipo.TRAEXP_Tipo,
                tipoOcupacionId: tipo._TRAEXP_Id,
                tipoOcupacionCheck: new FormControl(false, { validators: Validators.required, updateOn: 'blur' }),
            }));
            // console.log('formARrray', this.formArray);
            //console.log('comenzo la creacion de bnup');
        }
        // const idsTiposOcupaciones = [];
        //  this.formArray = <FormArray> this.formTipo.controls.ArrForms;
        // this.formArray.forEach((tipo, index) => {
        //    console.log('tipo:: ', tipo);
        //    if (tipo.tipoOcupacionCheck) {
        //      idsTiposOcupaciones.push(tipo.tipoOcupacionId);
        //    }
        //  });
        //  idsTiposOcupaciones
        //  console.log('idsTIposOCupaciones',idsTiposOcupaciones);
    };
    return IngresosInspComponent;
}());
export { IngresosInspComponent };
